// Derives `borrowed_metros` entries for every store whose own `stateAbbrev` differs from the
// state its metro is filed under (e.g. a Virginia clinic grouped under the Washington metro,
// which is filed under Maryland), so it also surfaces in its own physical state's dropdown.
// This mirrors the shape StatesDropdownSection/LocationsDropdown/FindMilanNearYou/OurStateStores
// already expect from curated Firestore data ({ name, pathname, borrow_from }) — it just computes
// it instead of requiring someone to hand-maintain it per state.
export const addCrossStateStores = (milanStores) => {
    if (!Array.isArray(milanStores) || milanStores.length === 0) return milanStores;

    const result = milanStores.map((state) => ({
        ...state,
        borrowed_metros: [...(state.borrowed_metros ?? [])],
    }));

    milanStores.forEach((state) => {
        state.metros?.forEach((metro) => {
            metro.stores?.forEach((store) => {
                const storeAbbrev = store.stateAbbrev?.trim().toUpperCase();
                const ownAbbrev = state.abbreviation?.trim().toUpperCase();
                if (!storeAbbrev || storeAbbrev === ownAbbrev) return;

                // Skip states Milan doesn't have a real dropdown/page for yet — a synthetic
                // entry with no metros would crash downstream consumers (e.g. FindMilanNearYou's
                // state select assumes metros[0] exists) and link to a /locations/xx/ page
                // gatsby-node never built.
                const targetState = result.find((s) => s.abbreviation?.trim().toUpperCase() === storeAbbrev);
                if (!targetState) return;

                const alreadyBorrowed = targetState.borrowed_metros.some(
                    (borrowed) => borrowed.pathname === metro.pathname && borrowed.borrow_from === state.abbreviation
                );
                if (!alreadyBorrowed) {
                    targetState.borrowed_metros.push({
                        name: metro.name,
                        pathname: metro.pathname,
                        borrow_from: state.abbreviation,
                    });
                }
            });
        });
    });

    return result;
};
